import React, { FunctionComponent, ReactNode } from 'react'
import classnames from 'classnames'

import styles from './styles.module.css'

interface FilterBoxProps {
  label: string
  children: ReactNode
  className?: string
}

const FilterBox: FunctionComponent<FilterBoxProps> = ({
  label,
  children,
  className,
}) => (
  <div className={classnames(className, styles.container)}>
    <h4>{label}:</h4>
    <div className={styles.children}>{children}</div>
  </div>
)

export default FilterBox
